<template>
  <div class="font-smaller">
    {{ notificationTitle }} are not moderated before they are posted, but they
    can be removed by the site moderators if they are found to be in
    contravention of our
    <a
      :href="`/engage/${partner}/about-information?show=commenting-and-discussion-policy`"
      target="_blank"
      rel="noopener"
    >
      Commenting and Discussion Policy
      <OpenInNewTabIcon />
    </a>
    - please read this policy before you post. {{ notificationTitle }} should be
    used for scholarly discussion of the content in question. You can
    <a
      :href="`/engage/${partner}/contact-information?show=faqs`"
      target="_blank"
      rel="noopener"
    >
      find more information about how to use the discussion feature here
      <OpenInNewTabIcon />
    </a>
    .
  </div>
</template>

<script>
import OpenInNewTabIcon from "~/components/OpenInNewTabIcon.vue";

export default {
  name: "CommunityDiscussionModerationNotification",
  components: {
    OpenInNewTabIcon,
  },
  props: {
    notificationTitle: { type: String, required: true },
  },
  computed: {
    partner() {
      return this.$config.partner;
    },
  },
};
</script>
